import React, { useState, useEffect, useRef } from 'react';
import Wrapper from './styles';
import ReactImageMagnify from 'react-image-magnify';
import { useCartContext } from '../../context/cart_context';

const ProductImages = ({ product }) => {
  const [main, setMain] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const { mainColor } = useCartContext();
  const sliderRef = useRef(null);
  useEffect(() => {
    if (product.productImageUrl) {
      setMain(product.productImageUrl[0]);
      setImageUrls(product.productImageUrl);
    }
  }, [product.productImageUrl]);
  const slide = (direction) => {
    if (sliderRef.current) {
      const { current } = sliderRef;
      const scrollAmount = 200; // Adjust scroll distance
      if (direction === 'left') {
        current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };
  return (
    <Wrapper>
      {main && (
        <ReactImageMagnify
          {...{
            className: 'main',
            imageClassName: 'main',
            smallImage: {
              sizes: '(max-width: 576px) 275px, (min-width: 992px) 450px', // Adjusted small image size
              isFluidWidth: true,
              alt: 'main',
              src: main,
            },
            largeImage: {
              src: main,
              width: 1600,
              height: 2200,
            },
            enlargedImageContainerDimensions: {
              width: '100%',
              height: '100%',
              zIndex: 2,
            },
            enlargedImageContainerClassName: 'magnify-container',
          }}
        />
      )}
      <div className='relative w-full group'>
        <button
          onClick={() => slide('left')}
          className='absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white shadow-md p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity disabled:opacity-0'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={2}
            stroke='currentColor'
            className='w-5 h-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M15.75 19.5L8.25 12l7.5-7.5'
            />
          </svg>
        </button>
        <div
          ref={sliderRef}
          className='flex gap-4 overflow-x-auto scroll-smooth scrollbar-hide px-1 py-2'
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }} // Hides scrollbar in Firefox/IE
        >
          {imageUrls.map((img, index) => {
            const isActive = img === main;
            return (
              <button
                key={index}
                onClick={() => setMain(img)}
                className={`relative flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden transition-all duration-300 m-2
                  ${
                    isActive
                      ? 'ring-2 ring-yellow-400 ring-offset-2 scale-105 opacity-100'
                      : 'opacity-60 hover:opacity-100 hover:scale-105'
                  }`}
              >
                <img
                  src={img}
                  alt={`Thumbnail ${index}`}
                  className='w-full h-full object-cover aspect-square'
                />
              </button>
            );
          })}
        </div>
        <button
          onClick={() => slide('right')}
          className='absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white shadow-md p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity'
        >
          {/* SVG Icon for Right */}
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={2}
            stroke='currentColor'
            className='w-5 h-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M8.25 4.5l7.5 7.5-7.5 7.5'
            />
          </svg>
        </button>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </Wrapper>
  );
};

export default ProductImages;
